import { render, staticRenderFns } from "./Wanway.vue?vue&type=template&id=306a1daf&scoped=true"
import script from "./Wanway.vue?vue&type=script&lang=js"
export * from "./Wanway.vue?vue&type=script&lang=js"
import style0 from "./Wanway.vue?vue&type=style&index=0&id=306a1daf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306a1daf",
  null
  
)

export default component.exports